// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "bundle." + chunkId + "." + {"235":"10edd4281fdec16728825bf468429e87","531":"bde7d432713268d9f295a44a9a0209c4"}[chunkId] + ".js";
};